export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/provider-restaurant.31693ba6-f089ad.svg";